import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import Form from "wonderbly-components/lib/Form";
import verifyRecaptcha from "src/common/facades/google/recaptcha";
import { useErrorMessages, useModel, useCountry } from "../../hooks";
import SectionHeading from "../SectionHeading";
import "./DynamicForm.scss";
import { sendGladlyForm } from "../../../facades/website";
import logger from "src/logger";
import { localiseUrlII } from "src/common/utils/format-localised-url";

const DynamicForm = (props) => {
  const { topology } = useModel();
  const { getErrorMessage } = useErrorMessages();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const country = useCountry();

  const onSubmit = async (values, { setError }) => {
    if (topology.google.siteKey) {
      const token = await executeRecaptcha("dynamic_form");
      // validate recaptcha
      try {
        await verifyRecaptcha(token);
      } catch ({ details }) {
        const errors = details.errors;
        const errorCode = errors[0].code;
        setError("base", {
          type: errorCode,
          message: getErrorMessage((error) => get(error, errorCode)),
        });
        return;
      }
    }

    // TODO: disable submit button when posting in wonderbly components
    if (props.form.type === "Gladly Help") {
      try {
        const response = await sendGladlyForm(values);
        if (response.ok) {
          const redirectUrl = localiseUrlII(country, `/help?message=success`);
          window.location = redirectUrl;
        } else {
          logger.error("Error sending Gladly contact form", response);
        }
      } catch (err) {
        const errorMessage = err.message;
        const errorCode = err.status;
        setError("base", {
          type: errorCode,
          message: getErrorMessage((err) => get(errorMessage, errorCode)),
        });
        return;
      }
    }
  };

  return (
    <div className="DynamicForm">
      {props.title && <SectionHeading tag="h1">{props.title}</SectionHeading>}
      <div className="container-guttered">
        <div className="DynamicForm__form">
          <Form fields={props.fields} onSubmit={onSubmit} />
        </div>
      </div>
    </div>
  );
};

DynamicForm.propTypes = {
  fields: PropTypes.array,
  title: PropTypes.string,
  form: PropTypes.object,
  type: PropTypes.string,
};

export default DynamicForm;
